import './author.css';
import author from '../../assets/list_eva_2_lil.jpg';
import linkedIn from '../../assets/linkedIn.webp';
import art4 from '../../assets/curve2.webp';

const Author = () => {
  return (
    <div className='author'>
        <img className="art4" alt='art' src={art4}/>
        <div className="authorContent">
            
            <h4>Wer dahintersteht </h4>
            <div className="authorDetails">
                <img className='authorImg' src={author} alt="" />
                <div className='authorText'>
                    <p>Ich bin Eva List &#40;1981&#41; - 16 Jahre Erfahrung in einem Zeitungsverlag, freiberufliche Texterin, Kommunikationsberaterin und Kinderbuchautorin. </p>
                    <p>Wie Marken mit den richten Worten Menschen beeinflussen, das habe ich als Marketing-Texterin gelernt. Seit über 20 Jahren nutze ich Worte, um Verbindung aufzubauen. Jetzt möchte ich dieses Wissen sinnvoll nutzen und einsetzen. Nicht für Marken, sondern für Menschen und Medien.</p>
                </div>
                
            </div>
            <p>Gemeinsam mit meinen Kindern Theo und Hannes entwickle ich den Mental-Media-Score. Ein einfaches und wirksames Tool, um Medienbewusstsein zu fördern. Für uns in der Familie funktioniert der Weg über die Analyse der Worte. Wie wirken die Worte, die wir lesen und die wir selbst schreiben? Für uns ein einfacher Zugang, der kritisches Denken, Bewusstsein und Fühlen fördert. Und außerdem Spaß macht.</p>
            <p>Ich freue mich, wenn wir uns vernetzen. </p>
            <div className="linkedin">
                <img src={linkedIn} alt="" />
                <a href="https://www.linkedin.com/in/eva-list/">Eva List | LinkedIn</a>
            </div>
        </div>
    </div>
  )
}

export default Author